
import { clipMargins, drawWithStyle } from "../../helpers/Draw";
import { SongView } from "../SongView";
import { ICanvasRenderOptions, IDraw2D } from "../abstraction/IDraw2D";
import { IDrawStyle } from "../abstraction/IDrawStyle";
import { IViewLayer } from "../abstraction/IViewLayer";

export class PositionDraw implements IDraw2D {

    protected _layer: IViewLayer;

    constructor() {

        this.posStyle = {
            strokeColor: "red",
            strokeWidth: 2
        };
        this.loopStyle = {
            opacity: 0.4,
            fillColor: "#00838F"
        }
    }

    attach(layer: IViewLayer) {
        this._layer = layer;
    }

    draw2D(ctx: CanvasRenderingContext2D, options: ICanvasRenderOptions) {

        const songView = this._layer.host as SongView;

        ctx.save();

        clipMargins(ctx, this._layer.host.margin, options.viewSize);

        ctx.resetTransform();

        const pos = songView.position;

        const song = songView.songTrack.song;

        const viewPos = options.viewTransform.transformPoint({ x: pos, y: 0 });

        ctx.beginPath();
        ctx.moveTo(viewPos.x, 10);
        ctx.lineTo(viewPos.x, this._layer.host.getViewSize().height);

        drawWithStyle(ctx, this.posStyle);

        if (song && song.loopRange) {

            const startPos = options.viewTransform.transformPoint({ x: song.loopRange.start, y: 0 });
            const endPos = options.viewTransform.transformPoint({ x: song.loopRange.start + song.loopRange.duration, y: 0 });

            ctx.beginPath();
            ctx.rect(startPos.x, this._layer.host.margin.y, endPos.x - startPos.x, options.viewSize.height - this._layer.host.margin.y);

            drawWithStyle(ctx, this.loopStyle);
        }

        ctx.restore();
    }

    posStyle: IDrawStyle;
    loopStyle: IDrawStyle;
}